import * as EffectsBuilders from './fx';
import { EffectsRenderBuffer } from '@frontend/lib/fabric/effects/EffectRenderBuffer';

class EffectsPipeline {
  effects = [
    new EffectsBuilders.SkewEffect(),
    new EffectsBuilders.ClippingMaskEffect(),
    new EffectsBuilders.OuterGlowEffect(),
    new EffectsBuilders.WarpEffect(),
  ];

  applyEffects(obj, ctx) {
    if (!obj || !obj.canvas || obj.isNotVisible()) {
      return false;
    }

    if (obj.isClippingMask) {
      return true;
    }

    const renderBuffer = new EffectsRenderBuffer();

    for (const effect of this.effects) {
      if (effect.isActive(obj)) {
        const effectResult = effect.apply(obj, renderBuffer);

        if (effectResult) {
          renderBuffer.update(effectResult);
        }
      }
    }

    if (!renderBuffer.canvas) {
      return false;
    }

    const { canvas, offsetX, offsetY } = renderBuffer;

    if (obj.shadow) {
      obj._setShadow(ctx);
    }

    ctx.drawImage(canvas, obj.left - offsetX, obj.top - offsetY);

    ctx.shadowBlur = 0;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;
    ctx.shadowColor = 'transparent';

    return true;
  }
}

export const Effects = new EffectsPipeline();
